import { shallowEqual, useSelector } from "react-redux";
import { getSelectedScenarioName, getSelectedWorkspaceName, getScenarios, } from "./selectors";
export const useCurrentScenWks = () => {
    return useSelector((state) => {
        let scenario = undefined;
        let workspace = undefined;
        if (state.scenarios) {
            scenario = getSelectedScenarioName(state.scenarios);
            workspace = getSelectedWorkspaceName(state.scenarios);
        }
        return { scenario, workspace };
    }, shallowEqual);
};
export const getAllScenarios = () => {
    return useSelector((state) => {
        const items = getScenarios(state.scenarios);
        return { scenarios: items };
    }, shallowEqual);
};
//# sourceMappingURL=hooks.js.map